/** CSP nonce injected by the backend into index.html (`<meta name="csp-nonce">`). */
export const CSP_NONCE_META_SELECTOR = 'meta[name="csp-nonce"]';

/**
 * @returns {string|null} CSP nonce from meta tag, or null when unavailable.
 */
export function getCspNonce() {
  if (typeof document === 'undefined') return null;
  const meta = document.querySelector(CSP_NONCE_META_SELECTOR);
  return meta?.getAttribute('content') || null;
}

/**
 * Sets `nonce` on a `<style>` (or other) element before DOM insertion (CSP style-src).
 * @param {HTMLElement} element
 * @returns {string|null} nonce applied, if any
 */
export function applyCspNonceToElement(element) {
  const nonce = getCspNonce();
  if (nonce && element) element.setAttribute('nonce', nonce);
  return nonce;
}
